module.exports = __webpack_public_path__ + "img/5.a69d280f.jpg";